// Mock data for Air Control Engineering website

export const heroData = {
  title: "Air Control Engineering",
  subtitle: "Leading Specialists in Industrial Air Pollution Control",
  tagline: "Making Industry Green and Pollution Free",
  description: "Turn-key projects for Air Pollution Control and Industrial Air Handling systems with 20+ years of expertise",
  ctaText: "Get Free Quote",
  ctaSecondary: "Explore Our Work"
};

export const aboutData = {
  title: "About Air Control Engineering",
  subtitle: "Professional Excellence Since 2002",
  description1: "Air Control Engineering Pvt. Ltd. is a professionally managed company, capable of handling turn-key projects of Air Pollution Control and Industrial Air Handling systems. We have the knowledge and expertise to offer optimum solutions related to Gas Cleaning and Handling Systems.",
  description2: "Today, we are recognized as the sole authorized representative of CASTLET Limited, UK, in India, bringing world-class ESP controller technology to Indian industries.",
  services: [
    "Electrostatic Precipitator (ESP)",
    "Bag Filter Systems", 
    "Explosion Vent (Cage Vent)",
    "Industrial Air Handling"
  ],
  expertise: [
    {
      title: "Supply & Installation",
      description: "Complete supply and installation of air pollution control equipment"
    },
    {
      title: "Refurbishing",
      description: "Modernizing existing equipment to achieve improved parameters"
    },
    {
      title: "Maintenance & Service",
      description: "Annual maintenance contracts and troubleshooting services"
    },
    {
      title: "Consultancy",
      description: "Expert consultation in air pollution control systems"
    }
  ]
};

export const productsData = {
  title: "Products & Services",
  subtitle: "Comprehensive Air Pollution Control Solutions",
  products: [
    {
      id: 1,
      name: "Electrostatic Precipitator (ESP)",
      description: "High-efficiency particulate collection systems for industrial applications. Several ACEPL's ESPs are working successfully in India and overseas.",
      features: ["99.9% Collection Efficiency", "Low Operating Cost", "Minimal Maintenance", "<50mg/Nm³ Emission Limit"],
      image: "/api/placeholder/400/300"
    },
    {
      id: 2,
      name: "Explosion Vent (Cage Vent)",
      description: "Precision engineered explosion diverters providing safety solutions for industrial processes.",
      features: ["Instant Response", "Corrosion Resistant", "Weather Protection", "Custom Sizing"],
      image: "/api/placeholder/400/300"
    },
    {
      id: 3,
      name: "Industrial Air Handling",
      description: "Tailored air handling solutions for various industrial applications ensuring optimal air quality and system performance.",
      features: ["Pressure Balancing", "Energy Optimization", "Overhauling Services", "Trouble Shooting"],
      image: "/api/placeholder/400/300"
    },
    {
      id: 4,
      name: "Bag Filter Systems",
      description: "Advanced fabric filtration technology for superior dust collection with expertise in baghouses and retrofitting solutions.",
      features: ["High Temperature Resistance", "Chemical Resistant Fabrics", "Pulse Jet Cleaning", "Modular Design"],
      image: "/api/placeholder/400/300"
    }
  ]
};

export const projectsData = {
  title: "Our Projects",
  subtitle: "Proven Track Record Across Industries",
  projects: [
    {
      id: 1,
      title: "Sri Aman Palm Oil Mill Sdn Bhd",
      category: "Palm Oil Industry",
      description: "Complete ESP installation for palm oil mill emissions control",
      image: "/api/placeholder/400/250",
      year: "2021",
      scope: "ESP Installation & Commissioning",
      place: "Malaysia",
      emission: "<50 mg/Nm³"
    },
    {
      id: 2,
      title: "Kuala Lumpur Kepong Berhad",
      category: "Palm Oil Industry",
      description: "Complete ESP installation for palm oil mill emissions control",
      image: "/api/placeholder/400/250",
      year: "2019",
      scope: "ESP Installation & Commissioning",
      place: "Malaysia",
      emission: "<50 mg/Nm³"
    },
    {
      id: 3,
      title: "Retus Palm Oil Mill",
      category: "Palm Oil Industry",
      description: "Complete ESP installation for palm oil mill emissions control",
      image: "/api/placeholder/400/250",
      year: "2019",
      scope: "ESP Installation & Commissioning",
      place: "Malaysia",
      emission: "<50 mg/Nm³"
    },
    {
      id: 4,
      title: "Salcra Palm Oil Mill",
      category: "Palm Oil Industry",
      description: "Complete ESP installation for palm oil mill emissions control",
      image: "/api/placeholder/400/250",
      year: "2016",
      scope: "ESP Installation & Commissioning",
      place: "Malaysia",
      emission: "<50 mg/Nm³"
    },
    {
      id: 6,
      title: "Palma Sur Oil Mill",
      category: "Palm Oil Industry",
      description: "Complete ESP installation for palm oil mill emissions control",
      image: "/api/placeholder/400/250",
      year: "2014",
      scope: "ESP Installation & Commissioning",
      place: "Guatemala",
      emission: "<50 mg/Nm³"
    },
    {
      id: 5,
      title: "Oleoflores Oil Mill",
      category: "Palm Oil Industry",
      description: "Complete ESP installation for palm oil mill emissions control",
      image: "/api/placeholder/400/250",
      year: "2016",
      scope: "ESP Installation & Commissioning",
      place: "Colombia",
      emission: "<50 mg/Nm³"
    },
    {
      id: 7,
      title: "Mideast Integrated Steels Ltd",
      category: "Steel Industry",
      description: "5 nos of Complete ESP installations for emissions control",
      image: "/api/placeholder/400/250",
      year: "2014",
      scope: "ESP Installation & Commissioning",
      place: "India",
      emission: "<120 mg/Nm³"
    },
    {
      id: 8,
      title: "Bhilai Steel Plant", 
      category: "Steel Industry",
      description: "Retrofitting and upgrading existing ESP systems for enhanced efficiency",
      image: "/api/placeholder/400/250",
      year: "2020",
      scope: "ESP Refurbishment",
      place: "India",
      emission: "<150 mg/Nm³"
    },
    {
      id: 9,
      title: "Hindustan Copper Limited",
      category: "Copper Industry", 
      description: "Retrofitting and upgrading existing ESP systems for enhanced efficiency",
      image: "/api/placeholder/400/250",
      year: "2017",
      scope: "ESP Refurbishment",
      place: "India",
      emission: "<150 mg/Nm³"
    },
    {
      id: 10,
      title: "Hindalco Industries Ltd",
      category: "Power Industry",
      description: "Retrofitting and upgrading existing ESP systems for enhanced efficiency",
      image: "/api/placeholder/400/250", 
      year: "2015",
      scope: "ESP Refurbishment",
      place: "India",
      emission: "<150 mg/Nm³"
    },
  ]
};

export const clienteleData = {
  title: "Our Valued Clientele", 
  subtitle: "Trusted by Leading Industries Worldwide",
  categories: [
    {
      name: "Power Industries",
      clients: [
        { name: "WBSEDCL", logo: "img/wbsedcl-211x202.png" },
        { name: "Adani Power", logo: "img/adani.png" },
        { name: "NSPCL", logo: "img/nspcl.png" },
        { name: "DVC", logo: "img/dvc-157x202.png" },
        { name: "Kalpataru Power", logo: "img/kalpataru.png" },
        { name: "Mackenzie Industrius", logo: "img/mackenzie.png" },
        { name: "WBPDCL", logo: "img/wbpdcl.png" },
        { name: "Reliance Power", logo: "img/reliance.png" }
      ]
    },
    {
      name: "Steel Industries", 
      clients: [
        { name: "Alstom", logo: "img/alstom.png" },
        { name: "SAIL", logo: "img/sail.png" },
        { name: "MESCO", logo: "img/mesco-200x184.png" },
        { name: "JSW", logo: "img/jsw.png" },
        { name: "Essar Steel", logo: "img/essar.png" },
        { name: "JSL", logo: "img/jindal.png" },
        { name: "Texmaco", logo: "img/texmaco.png" }
      ]
    },
    {
      name: "Palm Oil Mills",
      clients: [
        { name: "KLK Kekayaan", logo: "img/klk-kekayaan.png" },
        { name: "Oleoflores", logo: "img/oleoflores-logo.jpg" },
        { name: "SALCRA LAPOM", logo: "img/salcra-LAPOM.png" },
        { name: "Tradewinds", logo: "img/tradewinds-retus-200x162.png" },
        { name: "Sri Aman", logo: "img/felcra-sri-aman.png" }
      ]
    },
    {
      name: "Cement Industries",
      clients: [
        { name: "Shree Cement", logo: "img/shree-cement.png" },
        { name: "UltraTech Cement", logo: "img/ultratech.png" },
        { name: "Heidelberg Cement", logo: "img/heidelberg.png" },
        { name: "Prism Cement", logo: "img/prism.png" }
      ]
    },
    {
      name: "Other Industries",
      clients: [
        { name: "Andhra Paper", logo: "img/andhra-papaer.png" },
        { name: "TCE", logo: "img/tce.png" },
        { name: "ISGEC", logo: "img/ISGEC_logo.png" },
        { name: "HCL", logo: "img/HCL.png" },
        { name: "India Glycols", logo: "img/indiaglycols.png" },
        { name: "GEBR Pfeiffer", logo: "img/gebr.png" }
      ]
    }
  ]
};

export const contactData = {
  title: "Contact Us",
  subtitle: "Get in Touch for Your Air Pollution Control Needs",
  address: {
    title: "Corporate Location",
    line1: "Room 224, 'Centre Point'",
    line2: "21, Hemanta Basu Sarani",
    line3: "Kolkata 700 001"
  },
  emails: [
    "airoto@air-control.in",
    "airoto@hotmail.com" 
  ],
  phone: "+91 90512 88221",
  hours: "Monday – Friday: 10:00 AM – 6:00 PM",
  gst: "19AAECA2144G1ZY",
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.0945!2d88.3639!3d22.5726!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjLCsDM0JzIxLjQiTiA4OMKwMjEnNTAuMCJF!5e0!3m2!1sen!2sin!4v1234567890"
};

export const statsData = [
  { value: "50", label: "mg/Nm³ Emission Limit", suffix: "-" },
  { value: "100", label: "Explosions Averted", suffix: "+" },
  { value: "50", label: "ESPs Installed or Overhauled", suffix: "+" },
  { value: "CASTLET UK", label: "Sole Agent in India for ESP Controller", suffix: "" }
];